// import  { useEffect } from 'react';
import { Card, CardContent, Grid, Typography, Divider } from '@mui/material';
import { useProfile } from '../../providers/Profile';
import './PilotProfile.scss';

// type Props = {};

export default function PilotProfile() {
  const profileContext = useProfile();
  // const [profileDataLoading, setProfileDataLoading] = useState(true);
  const profileData = profileContext?.profile?.results;

  return (
    <Card>
      <CardContent sx={{ py: 4 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs sx={{ px: 2 }}>
            <Typography variant="h6" className="pilot-profile-label">
              Pilot Name:
            </Typography>
            <Typography
              variant="h4"
              className="pilot-profile-data-label"
              fontWeight={600}
            >
              {profileData?.['name']}
            </Typography>
          </Grid>
          <Grid item>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ mx: 2, my: 1, height: 48, alignSelf: 'stretch' }}
            />
          </Grid>
          <Grid item xs sx={{ px: 2 }}>
            <Typography variant="h6" className="pilot-profile-label">
              Seniority:
            </Typography>
            <Typography
              variant="h4"
              className="pilot-profile-data-label"
              fontWeight={600}
            >
              {' '}
              {profileData?.['seniority']}
            </Typography>
          </Grid>
          <Grid item>
            <Divider
              orientation="vertical"
              className="pilot-profile-label"
              flexItem
              sx={{ mx: 2, my: 1, height: 48, alignSelf: 'stretch' }}
            />
          </Grid>
          <Grid item xs sx={{ px: 2 }}>
            <Typography variant="h6" className="pilot-profile-label">
              Base:
            </Typography>
            <Typography
              variant="h4"
              className="pilot-profile-data-label"
              fontWeight={600}
            >
              {profileData?.['baseLocation']}
            </Typography>
          </Grid>
          <Grid item>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ mx: 2, my: 1, height: 48, alignSelf: 'stretch' }}
            />
          </Grid>
          <Grid item xs sx={{ px: 2 }}>
            <Typography variant="h6" className="pilot-profile-label">
              Equipment:
            </Typography>
            <Typography
              variant="h4"
              className="pilot-profile-data-label"
              fontWeight={600}
            >
              {profileData?.['equipment']}
            </Typography>
          </Grid>
          <Grid item>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ mx: 2, my: 1, height: 48, alignSelf: 'stretch' }}
            />
          </Grid>
          <Grid item xs sx={{ px: 2 }}>
            <Typography variant="h6" className="pilot-profile-label">
              Rank:
            </Typography>
            <Typography
              variant="h4"
              className="pilot-profile-data-label"
              fontWeight={600}
            >
              {profileData?.['position']}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
